module.exports = __webpack_public_path__ + "static/media/1on1_meeting_software_hr_app.6a912354.png";